import { forEach } from 'lodash';
import { parse, stringify } from './query-string';
const getShareableLink = (url, params = {}) => {
    const [host, queryAndHash = ''] = url.split('?');
    const [query = '', hash = ''] = queryAndHash.split('#');
    const queryParams = parse(query);
    // remove all wix-vod-* params from url
    forEach(queryParams, (_value, key) => {
        if (/wix-vod/.test(key)) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete queryParams[key];
        }
    });
    // convert safe params to string
    const queryString = stringify({
        ...queryParams,
        ...params,
    });
    const hashEnd = hash.length ? `#${hash}` : '';
    return `${host}${queryString}${hashEnd}`;
};
export const getUrlToWidget = (siteUrl, compId, params = {}) => {
    if (compId) {
        params['wix-vod-comp-id'] = compId;
    }
    return getShareableLink(siteUrl, params);
};
//# sourceMappingURL=get-url-to-widget.js.map